import React, { useState } from 'react';
import './EnvironmentPanel.css';

const EnvironmentPanel = ({ environmentImage, styleImage, onEnvironmentSelect, onStyleSelect }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Create object URLs for previews. In a real app we might want to cleanup these URLs.
    const previewUrl = environmentImage ? URL.createObjectURL(environmentImage) : null;
    const stylePreviewUrl = styleImage ? URL.createObjectURL(styleImage) : null;

    const togglePanel = () => {
        setIsOpen(!isOpen);
    };

    const handleEnvironmentUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (onEnvironmentSelect) {
                onEnvironmentSelect(file);
            }
        }
    };

    const handleStyleUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (onStyleSelect) {
                onStyleSelect(file);
            }
        }
    };

    const handleRemoveImage = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onEnvironmentSelect) {
            onEnvironmentSelect(null);
        }
    };

    const handleRemoveStyle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onStyleSelect) {
            onStyleSelect(null);
        }
    };

    return (
        <div className={`environment-panel ${isOpen ? 'open' : ''} `}>
            <button className="environment-toggle-tab" onClick={togglePanel}>
                <span className="toggle-text-vertical">ENVIRONNEMENT</span>
            </button>

            <div className="panel-content">
                <h2>ENVIRONNEMENT</h2>

                <div className="env-grid">
                    {/* Section Upload Environnement */}
                    <div className="upload-section">
                        <h3 className="upload-title">IMAGE ENVIRONNEMENT</h3>
                        {previewUrl ? (
                            <div className="thumbnail-container">
                                <img src={previewUrl} alt="Environment" className="env-thumbnail" />
                                <button className="remove-btn" onClick={handleRemoveImage}>×</button>
                            </div>
                        ) : (
                            <label className="upload-btn">
                                + UPLOAD
                                <input type="file" hidden onChange={handleEnvironmentUpload} />
                            </label>
                        )}
                    </div>

                    {/* Section Upload Style */}
                    <div className="upload-section">
                        <h3 className="upload-title">IMAGE STYLE</h3>
                        {stylePreviewUrl ? (
                            <div className="thumbnail-container">
                                <img src={stylePreviewUrl} alt="Style" className="env-thumbnail" />
                                <button className="remove-btn" onClick={handleRemoveStyle}>×</button>
                            </div>
                        ) : (
                            <label className="upload-btn">
                                + UPLOAD
                                <input type="file" hidden onChange={handleStyleUpload} />
                            </label>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnvironmentPanel;
